// De sessie zit in httpOnly-cookies. Dat is met opzet zo, maar het betekent ook dat
// JavaScript niet kan zien óf iemand is ingelogd. De landingspagina op / is statische
// HTML zonder React, en die moet dat tóch weten om een ingelogde bezoeker meteen door
// te sturen naar /coach.
//
// Daarom laat de app hier een spoor achter: alleen een vervalmoment, geen token en
// geen gegevens over de gebruiker. Wie dit leest of vervalst wint er niets mee - de
// server kijkt nog steeds alleen naar de cookie. Ontbreekt het spoor, dan gebeurt er
// niets bijzonders en ziet de bezoeker gewoon de landingspagina.
//
// LET OP: public/index.html leest deze sleutel rechtstreeks (daar kan niets uit dit
// bestand geïmporteerd worden). Hernoem je hem hier, pas hem daar dan ook aan.
export const SESSION_HINT_KEY = 'ccaSessionHint';

// Even lang als de refresh-cookie. Daarna is de sessie sowieso verlopen en heeft
// doorsturen geen zin meer.
const HINT_DUUR_MS = 7 * 24 * 60 * 60 * 1000;

/** Noteert dat er een geldige sessie is, zodat / doorstuurt naar /coach. */
export function markSessionActive(): void {
  try {
    localStorage.setItem(SESSION_HINT_KEY, String(Date.now() + HINT_DUUR_MS));
  } catch {
    // Privémodus of een volle opslag: zonder spoor werkt alles gewoon, alleen het
    // doorsturen vanaf de landingspagina blijft dan achterwege.
  }
}

/**
 * Wist het spoor. Belangrijk bij elke vorm van uitloggen of een afgekeurde sessie:
 * blijft het staan terwijl de cookie weg is, dan stuurt / door naar /coach, komt daar
 * het inlogvenster, en brengt sluiten je terug naar / - een rondje zonder uitgang.
 */
export function clearSessionHint(): void {
  try {
    localStorage.removeItem(SESSION_HINT_KEY);
  } catch {
    // Zie hierboven.
  }
}
